import { Section } from '@app/shared/ui/organisms/Instructions/Section';
import { prizeImage } from '@app/assets';

export function CompetitionSection() {
  return (
    <Section
      img={<img src={prizeImage} alt="prize" className="w-full max-w-[300px]" />}
      titleTranslationKey="competition_title"
      descriptionTranslationKey="competition_text"
    />
  );
}
